import { useMediaQuery } from "@mui/system";
import { Grid, Chip } from "@mui/material";
import { TextField, Labeled, SelectField, NumberField, ReferenceField, FunctionField } from "react-admin";
import { settings } from "app";
import { GenderOptionsId } from "utils/choices";
import { specialistRequests } from "api/specialistApi";
import { AdvancedSpecialistStatuses } from "utils/constants";
import { SectionTitle } from "features/SectionTitle";

const InfoSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Основна информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Име">
            <TextField source="firstName" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Презиме">
            <TextField source="secondName" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Фамилия">
            <TextField source="lastName" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="ЕГН/ЛНЧ">
            <TextField source="personId" />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Пол">
            <SelectField
              source="gender"
              choices={GenderOptionsId}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="ВСД Специалност">
            <ReferenceField
              source="advancedSpecializationId"
              reference={specialistRequests.getAdvancedSpecializationsSelect()}
            >
              <TextField source="nameBg" />
            </ReferenceField>
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Отстъпка от такса за обучение">
            <NumberField
              source="tuitionFeeDiscountPercentage"
              options={{ style: "unit", unit: "percent" }}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <Labeled label="Отстъпка от такса за обработка на документи">
            <NumberField
              source="documentProcessingFeeDiscountPercentage"
              options={{ style: "unit", unit: "percent" }}
            />
          </Labeled>
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          display="flex"
          alignItems="center"
        >
          <FunctionField
            render={record =>
              record.specializedAtMuSofia ? (
                <Chip
                  label="Специализиран в МУ София"
                  color="primary"
                  size="medium"
                />
              ) : (
                <Chip
                  label="Не е специализиран в МУ София"
                  variant="outlined"
                  size="medium"
                />
              )
            }
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          display="flex"
          alignItems="center"
        >
          <FunctionField
            render={record =>
              record.statusId === AdvancedSpecialistStatuses.InTraining ? (
                <Chip
                  label="Учащ"
                  color="warning"
                  size="medium"
                />
              ) : record.statusId === AdvancedSpecialistStatuses.Graduated ? (
                <Chip
                  label="Завършил"
                  color="success"
                  size="medium"
                />
              ) : (
                <Chip
                  label="Не завършил"
                  color="error"
                  size="medium"
                />
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default InfoSection;
